import React, { useState, useEffect } from 'react';

// Constants
const TOTAL_GIFS = 8;

// Generate array of GIF paths
const GIFS = Array.from({ length: TOTAL_GIFS }, (_, i) => {
    const number = String(i + 1).padStart(5, '0');
    return `/assets/gifs/arome_gif_${number}.gif`;
});

const BackgroundGif = () => {
    const [currentGif, setCurrentGif] = useState('');

    // Select a random GIF once on mount
    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * GIFS.length);
        setCurrentGif(GIFS[randomIndex]);
    }, []);

    return (
        <div className="fixed top-0 left-0 w-full h-full z-10">
            {currentGif && (
                <img
                    src={currentGif}
                    alt="Background GIF"
                    className="w-full h-full object-cover opacity-70"
                />
            )}
        </div>
    );
};

export default BackgroundGif;